import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";

export interface CountryData {
  id: number;
  name: string;
  iso2: string;
}

export interface CountryDetailedData extends CountryData {
  iso3: string;
  phonecode: string;
  capital: string;
  currency: string;
  native: string;
  emoji: string;
  emojiU: string;
}

export interface StateData {
  id: number;
  name: string;
  iso2: string;
}

export interface StateDetailedData extends StateData {
  country_id: string;
  country_code: string;
}

export interface CityData {
  id: number;
  name: string;
}
class CountriesService {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  getCountriesList(): Promise<ApiResponseV2<CountryData[]>> {
    return HttpClientV2.get(`${this.path}/countries`);
  }

  getStatesList(iso2CountryCode: string): Promise<ApiResponseV2<StateData[]>> {
    return HttpClientV2.get(`${this.path}/countries/${iso2CountryCode}`);
  }
}

export default new CountriesService("api/countries-info");
